import { aiPersonasApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AI_PERSONAS_ACTION_TYPE = createNamedActions('aiPersonas', {
  GET_AI_PERSONAS: 'GET_AI_PERSONAS',
  GET_AI_PERSONA_BY_ID: 'GET_AI_PERSONA_BY_ID',
  CREATE_AI_PERSONA: 'CREATE_AI_PERSONA',
  UPDATE_AI_PERSONA: 'UPDATE_AI_PERSONA',
  DELETE_AI_PERSONA: 'DELETE_AI_PERSONA',
  GET_GLOBAL_AI_PERSONAS: 'GET_GLOBAL_AI_PERSONAS',
  CLONE_AI_PERSONA: 'CLONE_AI_PERSONA',
  GET_AI_PERSONA_SECURITY_GROUPS: 'GET_AI_PERSONA_SECURITY_GROUPS',
  SET_AI_PERSONA_SECURITY_GROUPS: 'SET_AI_PERSONA_SECURITY_GROUPS',
  RESET_AI_PERSONAS_STATE: 'RESET_AI_PERSONAS_STATE',
});

export const getAiPersonasAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiPersonasApi.getAiPersonas(params);

  return dispatch({
    type: AI_PERSONAS_ACTION_TYPE.GET_AI_PERSONAS,
    payload: data,
  });
});

export const getAiPersonaByIdAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await aiPersonasApi.getAiPersonaById(id);

  return dispatch({
    type: AI_PERSONAS_ACTION_TYPE.GET_AI_PERSONA_BY_ID,
    payload: data,
  });
});

export const createAiPersonaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiPersonasApi.createAiPersona(params);

  return dispatch({
    type: AI_PERSONAS_ACTION_TYPE.CREATE_AI_PERSONA,
    payload: data,
  });
});

export const updateAiPersonaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiPersonasApi.updateAiPersona(params);

  return dispatch({
    type: AI_PERSONAS_ACTION_TYPE.UPDATE_AI_PERSONA,
    payload: data,
  });
});

export const deleteAiPersonaAction = catchAsyncActionError(id => async dispatch => {
  await aiPersonasApi.deleteAiPersona(id);

  return dispatch({
    type: AI_PERSONAS_ACTION_TYPE.DELETE_AI_PERSONA,
    payload: id,
  });
});

export const getGlobalAiPersonasAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiPersonasApi.getGlobalAiPersonas(params);

  return dispatch({
    type: AI_PERSONAS_ACTION_TYPE.GET_GLOBAL_AI_PERSONAS,
    payload: data,
  });
});

export const cloneAiPersonaAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await aiPersonasApi.cloneAiPersona(id);

  return dispatch({
    type: AI_PERSONAS_ACTION_TYPE.CLONE_AI_PERSONA,
    payload: data,
  });
});

export const getAiPersonaSecurityGroupsAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await aiPersonasApi.getAiPersonaSecurityGroups(id);

  return dispatch({
    type: AI_PERSONAS_ACTION_TYPE.GET_AI_PERSONA_SECURITY_GROUPS,
    payload: { id, securityGroupIds: data },
  });
});

export const setAiPersonaSecurityGroupsAction = catchAsyncActionError(
  (id, securityGroupIds) => async dispatch => {
    await aiPersonasApi.setAiPersonaSecurityGroups(id, securityGroupIds);

    return dispatch({
      type: AI_PERSONAS_ACTION_TYPE.SET_AI_PERSONA_SECURITY_GROUPS,
      payload: { id, securityGroupIds },
    });
  },
);

export const resetAiPersonasStateAction = () => ({
  type: AI_PERSONAS_ACTION_TYPE.RESET_AI_PERSONAS_STATE,
});
